var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 35,
    viewBox: "0 0 35.66 35",
    width: 35.66,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.83 0a17.667 17.667 0 0 1 17.83 17.5 17.667 17.667 0 0 1 -17.83 17.5 17.667 17.667 0 0 1 -17.83-17.5 17.667 17.667 0 0 1 17.83-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.83018875 1.5c-4.3672409 0-8.47163963 1.66778946-11.55714989 4.69615936-3.07793998 3.02094078-4.77303886 7.03539086-4.77303886 11.30384064s1.69509888 8.28289986 4.77303886 11.30384064c3.08551026 3.0283699 7.18990899 4.69615936 11.55714989 4.69615936 4.36724091 0 8.47163963-1.66778946 11.55714989-4.69615936 3.07793999-3.02094078 4.77303886-7.03539086 4.77303886-11.30384064s-1.69509887-8.28289986-4.77303886-11.30384064c-3.08551026-3.0283699-7.18990898-4.69615936-11.55714989-4.69615936m0-1.5c9.84733963 0 17.83018875 7.83502007 17.83018875 17.5s-7.98284912 17.5-17.83018875 17.5-17.83018875-7.83502007-17.83018875-17.5 7.98284912-17.5 17.83018875-17.5z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.958 14.554h-10.958a5.005 5.005 0 0 1 -5-5v-4.554a5.006 5.006 0 0 1 5-5h10.958a5.006 5.006 0 0 1 5 5v4.554a5.005 5.005 0 0 1 -5 5zm-7.835-11.934v8.15l6.462-3.87z",
    fill: "#fff",
    transform: "translate(7.519 10.466)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.5875f36b3b35400e50a163cb50a345d8.svg";
export { ForwardRef as ReactComponent };